import React from "react";
import { ReactComponent as ConflictCaseSvg } from "../../assets/icons/conflictcase.svg";

export default function ConflictCaseIcon({ size = 20, className = "" }) {
  return (
    <ConflictCaseSvg
      className={className}
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      style={{
        display: "inline-block",
        verticalAlign: "middle",
      }}
    />
  );
}
